var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('img',{staticStyle:{"width":"20%","height":"20%"},attrs:{"alt":"The Shaquille","src":require("../assets/shaq.png")}}),_c('ShaqFAQ')],1)}
var staticRenderFns = []

export { render, staticRenderFns }